import { assembleQueueState } from '../playback/playback-queue-chunks.js';
/** In-memory chunked store, same layout as IndexedDB. Each save applies all-or-nothing. */
export class MemoryPlaybackEventStore {
    legacy;
    meta = null;
    chunks = new Map();
    /** `legacy` seeds an old single-key queue, to test the migration. */
    constructor(legacy = null) {
        this.legacy = legacy;
    }
    async load() {
        if (this.meta) {
            return assembleQueueState({ ...this.meta }, (index) => this.chunks.get(index)?.map((event) => ({ ...event })));
        }
        if (this.legacy) {
            return JSON.parse(JSON.stringify(this.legacy));
        }
        return [];
    }
    async save(write) {
        const chunks = new Map(this.chunks);
        for (const index of write.deleteChunks)
            chunks.delete(index);
        for (const chunk of write.chunks) {
            chunks.set(chunk.index, chunk.events.map((event) => ({ ...event })));
        }
        this.chunks = chunks;
        this.meta = {
            ...write.meta,
            ...(write.meta.batchFailure ? { batchFailure: { ...write.meta.batchFailure } } : {}),
        };
        this.legacy = null;
    }
    /** Stored chunk numbers, for tests. */
    chunkIndexes() {
        return [...this.chunks.keys()].sort((a, b) => a - b);
    }
    /** True while an old single-key queue is still stored, for tests. */
    hasLegacy() {
        return this.legacy !== null;
    }
}
//# sourceMappingURL=memory-playback-event-store.js.map